import React, { useState, useEffect } from "react";
import {
	Box,
	Typography,
	List,
	ListItem,
	ListItemText,
	ListItemIcon,
	ListItemButton,
	Divider,
	Button,
	Menu,
	MenuItem,
} from "@mui/material";
import StoreIcon from "@mui/icons-material/Store";
import Logo from "../../assets/logo/Logo.svg";
import { useLocation, useNavigate } from "react-router-dom";
import LogoutIcon from "@mui/icons-material/Logout";
import SettingsIcon from "@mui/icons-material/Settings";
import EventIcon from "@mui/icons-material/Event";
import KeyboardArrowDownOutlinedIcon from "@mui/icons-material/KeyboardArrowDownOutlined";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import BookmarkIcon from "@mui/icons-material/Bookmark";
import DescriptionIcon from "@mui/icons-material/Description";

const paths = {
	"/get-started": 18,
	"/get-started/": 18,
	"/company": 13,
	"/company/documents": 19,
	"/company/deadlines": 20,
};

const Sidebar = () => {
	const location = useLocation();
	const [open, setOpen] = useState({
		company: false,
		accounting: false,
		businessSupport: false,
		legalSupport: false,
	});
	const [selectedIndex, setSelectedIndex] = useState(
		paths[location.pathname]
	);
	const navigate = useNavigate();
	const [storageValue, setStorageValue] = useState(() => {
		return localStorage.getItem("activeForm") || "";
	});

	const [anchorEl, setAnchorEl] = useState(null);

	const handleSettingsClick = (event) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const handleListItemClick = (index, route) => {
		setSelectedIndex(index);
		if (route) {
			navigate(route);
		}
	};
	const profileName = localStorage.getItem("username");
	const handleLogout = () => {
		localStorage.removeItem("activeForm");
		localStorage.removeItem("token");
		localStorage.removeItem("username");
		localStorage.removeItem("useremail");
		localStorage.removeItem("userId");
		localStorage.removeItem("companyName");
		localStorage.removeItem("registeredEmail");
		navigate("/login");
	};

	useEffect(() => {
		setSelectedIndex(paths[location.pathname]);
	}, [location.pathname]);

	useEffect(() => {
		const handleStorageChange = () => {
			const newValue = localStorage.getItem("activeForm");
			setStorageValue(newValue);
		};

		window.addEventListener("storage", handleStorageChange);

		return () => {
			window.removeEventListener("storage", handleStorageChange);
		};
	}, []);

	return (
		<Box
			sx={{
				backgroundColor: "#110c27",
				display: "flex",
				flexDirection: "column",
				padding: "1.5rem",
				height: "100vh",
			}}>
			{/* 🔹 Top Section */}
			<Box>
				<img src={Logo} alt='Logo' width={"200px"} />
				<List component='nav' sx={{ marginTop: "1rem" }}>
					{location.pathname === "/company" && (
						<ListItem disablePadding>
							<ListItemButton
								selected={selectedIndex === 13}
								onClick={() => {
									handleListItemClick(13, "/company");
								}}
								sx={{
									backgroundColor:
										selectedIndex === 13
											? "#2d0c71 !important"
											: "transparent",
									padding: "0.5rem",
									borderRadius: "0.5rem",
								}}>
								<ListItemIcon sx={{ minWidth: 0 }}>
									<BookmarkIcon
										sx={{ color: "#FFFFFF" }}
										fontSize='small'
									/>
								</ListItemIcon>
								<ListItemText
									primary='Incorporation'
									sx={{
										color: "#FFFFFF",
										marginLeft: "0.25rem",
									}}
								/>
							</ListItemButton>
						</ListItem>
					)}
					{(location.pathname === "/get-started" ||
						location.pathname === "/get-started/" ||
						location.pathname === "/company/deadlines" ||
						location.pathname === "/company/documents") && (
						<>
							<ListItem disablePadding>
								<ListItemButton
									selected={selectedIndex === 18}
									onClick={() => {
										handleListItemClick(18, "/get-started");
									}}
									sx={{
										backgroundColor:
											selectedIndex === 18
												? "#2d0c71 !important"
												: "transparent",
										padding: "0.5rem",
										borderRadius: "0.5rem",
									}}>
									<ListItemIcon sx={{ minWidth: 0 }}>
										<BookmarkIcon
											sx={{ color: "#FFFFFF" }}
											fontSize='medium'
										/>
									</ListItemIcon>
									<ListItemText
										primary='Get Started'
										sx={{
											color: "#FFFFFF",
											marginLeft: "1rem",
										}}
									/>
								</ListItemButton>
							</ListItem>
							<Divider
								sx={{ backgroundColor: "#FFFFFF", my: 2 }}
							/>
							{/* <ListItem disablePadding>
								<ListItemButton
									selected={selectedIndex === 19}
									onClick={() => {
										handleListItemClick(
											19,
											"/company/documents"
										);
									}}
									sx={{
										backgroundColor:
											selectedIndex === 19
												? "#2d0c71 !important"
												: "transparent",
										padding: "0.5rem",
										borderRadius: "0.5rem",
									}}>
									<ListItemIcon sx={{ minWidth: 0 }}>
										<DescriptionIcon
											sx={{ color: "#FFFFFF" }}
											fontSize='medium'
										/>
									</ListItemIcon>
									<ListItemText
										primary='My Documents'
										sx={{
											color: "#FFFFFF",
											marginLeft: "1rem",
										}}
									/>
								</ListItemButton>
							</ListItem>
							<ListItem disablePadding>
								<ListItemButton
									selected={selectedIndex === 20}
									onClick={() => {
										handleListItemClick(
											20,
											"/company/deadlines"
										);
									}}
									sx={{
										backgroundColor:
											selectedIndex === 20
												? "#2d0c71 !important"
												: "transparent",
										padding: "0.5rem",
										borderRadius: "0.5rem",
									}}>
									<ListItemIcon sx={{ minWidth: 0 }}>
										<EventIcon
											sx={{ color: "#FFFFFF" }}
											fontSize='medium'
										/>
									</ListItemIcon>
									<ListItemText
										primary='My Deadlines'
										sx={{
											color: "#FFFFFF",
											marginLeft: "1rem",
										}}
									/>
								</ListItemButton>
							</ListItem> */}
						</>
					)}
				</List>
			</Box>

			<Box sx={{ marginTop: "auto" }}>
				{(location.pathname === "/get-started" ||
					location.pathname === "/company/deadlines" ||
					location.pathname === "/company/documents") && (
					<Button
						variant='outlined'
						fullWidth
						sx={{
							color: "#FFFFFF",
							borderColor: "#FFFFFF",
							textTransform: "none",
							justifyContent: "flex-start",
							padding: "0.5rem 1rem",
							display: "flex",
							alignItems: "center",
							borderRadius: 2,
							ml: 0,
						}}>
						<StoreIcon
							sx={{ marginRight: "8px", color: "#FFFFFF" }}
							fontSize='small'
						/>
						Refer & Earn
					</Button>
				)}
				{/* Divider */}
				<Divider sx={{ backgroundColor: "#FFFFFF", my: 2 }} />

				{/* Settings List Item */}
				{(location.pathname === "/get-started" ||
					location.pathname === "/company/deadlines" ||
					location.pathname === "/company/documents") && (
					<ListItem disablePadding>
						<ListItemButton sx={{ padding: "0.5rem", ml: 0 }}>
							<ListItemIcon sx={{ minWidth: 0 }}>
								<SettingsIcon
									sx={{ color: "#FFFFFF" }}
									fontSize='medium'
								/>
							</ListItemIcon>
							<ListItemText
								primary='Settings'
								sx={{
									color: "#FFFFFF",
									marginLeft: "1rem",
									fontSize: "0.875rem",
								}}
							/>
						</ListItemButton>
					</ListItem>
				)}
				{/* Dropdown Menu for Logout */}
				<Menu
					anchorEl={anchorEl}
					open={Boolean(anchorEl)}
					onClose={handleClose}
					sx={{
						"& .MuiPaper-root": {
							backgroundColor: "#2d0c71", // Background color of the dropdown
						},
					}}>
					<MenuItem
						onClick={handleLogout}
						sx={{
							color: "white", // Text color
							"&:hover": {
								backgroundColor: "#0047AB", // Darker blue on hover
							},
						}}>
						<LogoutIcon
							fontSize='small'
							sx={{ marginRight: "8px", color: "white" }}
						/>
						Logout
					</MenuItem>
				</Menu>

				{/* User Profile Section */}
				<Box
					display='flex'
					alignItems='center'
					sx={{ marginTop: "1rem" }}>
					<AccountCircleIcon
						sx={{ fontSize: 30, color: "white", ml: 0.5 }}
					/>

					<Typography
						variant='body2'
						sx={{
							color: "white",
							fontWeight: "400",
							marginLeft: "0.75rem",
							textTransform: "capitalize",
						}}>
						{profileName}
					</Typography>
					<KeyboardArrowDownOutlinedIcon
						onClick={handleSettingsClick}
						sx={{ color: "white", ml: 2 }}
					/>
				</Box>
			</Box>
		</Box>
	);
};

export default Sidebar;
